
@switch (Idpantalla) {
    @case (1) { <!-- NOTIFICACION ELECTRONICAS -->
    <oaj-notificacion-itx></oaj-notificacion-itx>
  }
    @case (2) { <!-- NO NOTIFICADAS-->
    <oaj-no-notificadas-itx></oaj-no-notificadas-itx>
  }
  @case (3) { <!-- DEMANDAS ELECTRONICAS -->
    <oaj-electronic-demand-itx></oaj-electronic-demand-itx>
  }
    @case (4) { <!-- PROMOCIONES ELECTRONICAS -->
    <oaj-promocion-itx></oaj-promocion-itx>
  }
  @case (5) { <!-- EXPEDIENTE ELECTRONICO-->
    <oaj-expediente-electronico-itx></oaj-expediente-electronico-itx>
  }
    @case (6) { <!-- INCIDENCIAS -->
    <oaj-incidencias-itx></oaj-incidencias-itx>
  }
  @case (7) { <!-- REIMPRESION DE ACUSES -->
    <oaj-reimpresion-acuses-itx></oaj-reimpresion-acuses-itx>
  }
 @case (8) { <!-- SERVICIO -->
    <oaj-servicio-itx></oaj-servicio-itx>
  }
   @case (9) { <!-- DIAS NHABILES -->
    <oaj-config-dia-inhabil></oaj-config-dia-inhabil>
  }
  @case (10) { <!-- ALTA DE USUARIOS -->
    <oaj-alta-usuario-itx></oaj-alta-usuario-itx>
  }

  @case (11) { <!-- AYUDA -->
    <oaj-help-itx></oaj-help-itx>
  }
  @case (12) { <!-- consulta demanda -->
    <oaj-consulta-demanda-itx></oaj-consulta-demanda-itx>
  }
}
